import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useWebhookCache } from './cache'
import { Logger, toResponseError, type WebhookRemoveInput, type WebhookRemoveSuccess } from '@terros/common'

const logger = new Logger('useWebhooks')

export function useRemoveWebhook(): RemoveHookResponse<WebhookRemoveInput> {
  logger.verbose('calling useRemoveWebhook')
  const mutation = useTantalimMutation<WebhookRemoveInput, WebhookRemoveSuccess>({
    url: '/webhook/remove',
  })
  const cache = useWebhookCache()

  async function remove(input: WebhookRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeItem(input.webhookId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
